import { render, staticRenderFns } from "./StopReport.vue?vue&type=template&id=051ec4ea&scoped=true&"
import script from "./StopReport.vue?vue&type=script&lang=js&"
export * from "./StopReport.vue?vue&type=script&lang=js&"
import style0 from "./StopReport.vue?vue&type=style&index=0&id=051ec4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ec4ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051ec4ea')) {
      api.createRecord('051ec4ea', component.options)
    } else {
      api.reload('051ec4ea', component.options)
    }
    module.hot.accept("./StopReport.vue?vue&type=template&id=051ec4ea&scoped=true&", function () {
      api.rerender('051ec4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/StopReport.vue"
export default component.exports